import React from 'react';

import Tooltip from '../../../../components/Tooltip';

// Note: Used in the Comapny page and QV
const MpiMetric = () => (
  <div className="mpi-metric">
    <i className="hicon-star-filled text-blue" />
    <p className="text-blue text-bold">MPI</p>
    <Tooltip
      colorVariant="light"
      overlayClassName="mpi-metric__tooltip"
      content={(
        <div className="mpi-metric__tooltip-box">
          <p className="mpi-metric__tooltip-head ">Mobile Perfomance Index</p>
          <p className="mpi-metric__tooltip-content">The Mobile Performance Index (MPI) is a single metric providing a proprietary view of growth and engagement while capturing the best signal relevant to company performance.</p>
        </div>
      )}
    >
      <i className="hicon-question-circle cursor-pointer text-16" />
    </Tooltip>
  </div>
);

export default MpiMetric;
